export const queryifyObject = (obj) => {
	let params = '?';
	let counter = 0;
	for (const [key, value] of Object.entries(obj)) {
		if (counter > 0) {
			params += '&';
		}

		params += `${key}=${encodeURIComponent(value)}`;
		counter++;
	}

	return params;
};
